import PropTypes from "prop-types";

const iconPropTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    fill: PropTypes.string,
};

const iconDefaultProps = {
    fill: '#000',
    width: 20,
    height: 20,
}

export { iconPropTypes, iconDefaultProps };
